import type { Recent } from "app/custom-hooks/useRecentsHook";

export const getRecentWebsiteData = (item: Recent) => {
    const { data } = item;
    const { mainItem, pageTitle, stateName, comparedItems, resources } = data;

    const icons = [resources.mainItemFavIcon, ...resources.comparedItemsFavicon];
    const competitorsLength = comparedItems.length;
    // @ts-ignore
    const firstCompetitor = competitorsLength > 0 ? comparedItems[0] : null;

    let otherCount = 0;

    if (competitorsLength > 1) {
        otherCount = competitorsLength - 1;
    }

    return { icons, mainItem, otherCount, firstCompetitor, competitorsLength, pageTitle, stateName };
};
